<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table
      noDataText="Nenhuma Mensagem encontrada"
      ref="table"
      :data="itens"
      pagination
      :max-items="itemsPerPage"
      search
    >
      <!-- Header -->
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <!-- Botão Nova Mensagem -->
        <ActionButtonNew
          :subjectPermission="subjectPermission"
          @toggleSideBar="newEvent()"
        >
          Adicionar Mensagem
        </ActionButtonNew>

        <!-- Seleção das Páginas -->
        <SelectPagination
          :currentPage="currentPage"
          :itemsPerPage="itemsPerPage"
          :length="itens.length"
          @update="itemsPerPage = $event"
        />
      </div>

      <template slot="thead">
        <vs-th class="table-head" sort-key="codigoMensagem">Id Mensagem</vs-th>
        <vs-th class="table-head">Assunto</vs-th>
        <vs-th class="table-head table-content-center">Whatsapp</vs-th>
        <vs-th class="table-head table-content-center">E-mail</vs-th>
        <vs-th class="table-head table-content-center">SMS</vs-th>
        <vs-th class="table-head table-content-center">Ativo</vs-th>
        <vs-th
          class="table-head"
          v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >Ações</vs-th
        >
      </template>

      <!-- Body -->
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- Id Mensagem -->
            <vs-td>{{ tr.codigoMensagem }}</vs-td>

            <!-- Assunto -->
            <vs-td>{{ tr.assunto }}</vs-td>

            <!-- Canal WhatsApp -->
            <vs-td class="table-content-center">
              <vs-checkbox disabled v-model="tr.canalWhatsapp" />
            </vs-td>

            <!-- Canal Email -->
            <vs-td class="table-content-center">
              <vs-checkbox disabled v-model="tr.canalEmail" />
            </vs-td>

            <!-- Canal SMS -->
            <vs-td class="table-content-center">
              <vs-checkbox disabled v-model="tr.canalSms" />
            </vs-td>

            <!-- Mensagem Ativa -->
            <vs-td class="table-content-center">
              <vs-checkbox disabled v-model="tr.mensagemAtiva" />
            </vs-td>

            <!-- Ações -->
            <vs-td>
              <div class="flex gap-2">
                <router-link
                  :to="`/mensageria/editar/${tr.idMensageriaMensagem}`"
                >
                  <vs-button
                    v-tooltip="'Editar'"
                    radius
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="d-inline"
                    v-if="$can($actionsDefault.Escrita, subjectPermission)"
                  >
                  </vs-button>
                </router-link>

                <vs-button
                  v-tooltip="'Excluir'"
                  radius
                  color="danger"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-trash"
                  class="d-inline"
                  @click="
                    openConfirmDelete(
                      tr.idMensageriaMensagem,
                      tr.codigoMensagem,
                    )
                  "
                ></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import ActionButtonNew from './../../../../../utils/list/header/ActionButtonNew';
import SelectPagination from './../../../../../utils/list/header/SelectPagination';
import service from './../../../../../services';
import notify from './../../../../../utils/notify';

export default {
  props: ['subjectPermission'],
  components: {
    ActionButtonNew,
    SelectPagination,
  },
  data() {
    return {
      isMounted: false,
      itemsPerPage: 10,
      itens: [],
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    newEvent() {
      this.$emit('newEvent');
    },
    async getList() {
      try {
        this.$vs.loading();

        const result = await service.getAll('mensageria', {}, 'mensagem');
        if (Array.isArray(result.data)) {
          this.itens = result.data;
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    openConfirmDelete(idMensageriaMensagem, codigoMensagem) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Confirmação',
        text: `Deseja excluir a mensagem ${codigoMensagem}?`,
        acceptText: 'Sim',
        cancelText: 'Não',
        accept: () => this.delete(idMensageriaMensagem),
      });
    },
    async delete(idMensageriaMensagem) {
      try {
        this.$vs.loading();

        await service.delete('mensageria', `mensagem/${idMensageriaMensagem}`);
        await this.getList();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss">
@import './../../../../../utils/list/style-table';

.table-head {
  width: 16%;
}

.table-content-center {
  .vs-table-text {
    display: block;
    text-align: center;
  }

  span {
    .con-vs-checkbox {
      justify-content: center !important;
    }
  }
}

#data-list-list-view {
  @include style-table;
}
</style>
